// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import type { ReactNode } from "react"

interface EmptyStateProps {
  title: string
  body: string
  action?: ReactNode
  className?: string
}

/**
 * Honest empty state: explains what's missing and, when there is one,
 * what to do next — never a placeholder that implies fabricated data.
 */
export function EmptyState({ title, body, action, className }: EmptyStateProps) {
  return (
    <div
      className={`flex flex-col items-center gap-3 rounded-bb-xl border border-dashed border-line bg-paper px-6 py-10 text-center ${className ?? ""}`}
    >
      <h2 className="text-lg font-semibold text-ink">{title}</h2>
      <p className="max-w-prose text-sm text-ink-2">{body}</p>
      {action}
    </div>
  )
}
